import {
  QUERY_SUBSCRIPTION_CHANGE_RULES,
  CHANGE_PLAN_BANNER,
  MUTATION_SUBSCRIPTION_CHANGE
} from 'src/app/queries/queries'

const planChange = (input, success, error) => {
  return {
    type: 'API:QUERY:SUBSCRIPTION:CHANGE:RULES',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: QUERY_SUBSCRIPTION_CHANGE_RULES,
      variables: {
        input: input
      }
    }
  }
}
const planChangeBanner = (success, error) => {
  return {
    type: 'API:QUERY:CHANGE:PLAN:BANNER',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: CHANGE_PLAN_BANNER,
      variables: {
        display_position: 'subscription_type_change_rule_banner'
      }
    }
  }
}

const mutationPlanChange = (input, success, error) => ({
  type: 'API:PLAN:CHANGE',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: MUTATION_SUBSCRIPTION_CHANGE,
    variables: {
      input: input
    }
  },
  success: success,
  error: error
})

export default {
  planChange,
  planChangeBanner,
  mutationPlanChange
}
